import { render, staticRenderFns } from "./kComponent.vue?vue&type=template&id=711ec42e&"
import script from "./kComponent.vue?vue&type=script&lang=js&"
export * from "./kComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports